import { Outlet, useLocation } from "react-router-dom";
import SideBar from "../components/SideBar/SideBar";
import Header from "../components/Header/Header";
import WorkspaceHeading from "../components/WorkspaceHeading/WorkspaceHeading";
import { useEffect, useRef, useState } from "react";

const SidebarLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(() => {
    try { return JSON.parse(localStorage.getItem("isSidebarOpen") || "true") === true; }
    catch { return true; }
  });
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.matchMedia("(max-width: 900px)").matches);
  const navigationRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  useEffect(() => {
    const query = window.matchMedia("(max-width: 900px)");
    const update = () => { setIsMobile(query.matches); setMobileOpen(false); };
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);
  useEffect(() => {
    if (isMobile && !mobileOpen) navigationRef.current?.setAttribute("inert", "");
    else navigationRef.current?.removeAttribute("inert");
    if (!mobileOpen) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setMobileOpen(false);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [isMobile, mobileOpen]);
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);
  const toggleSidebar = () => {
    if (window.matchMedia("(max-width: 900px)").matches) {
      setMobileOpen(value => !value);
    } else {
      setIsSidebarOpen(value => {
        const next = !value;
        localStorage.setItem("isSidebarOpen", JSON.stringify(next));
        return next;
      });
    }
  };
  return (
    <div className={"control-tower " + (isSidebarOpen ? "navigation-expanded" : "navigation-collapsed") + (mobileOpen ? " mobile-navigation-open" : "") + (location.pathname.startsWith("/live-fleet") ? " fleet-shell" : "")}>
      {mobileOpen && <button className="navigation-backdrop" aria-label="Close navigation" onClick={() => setMobileOpen(false)} />}
      <div ref={navigationRef} aria-hidden={isMobile && !mobileOpen ? true : undefined}><SideBar isSidebarOpen={isSidebarOpen || mobileOpen} toggleSidebar={toggleSidebar} /></div>
      <div className="workspace">
        <Header onToggleNavigation={toggleSidebar} navigationOpen={isMobile ? mobileOpen : isSidebarOpen} />
        {!location.pathname.startsWith("/live-fleet") && <WorkspaceHeading />}
        <main id="workspace-content" className="main_area_inset_shadow"><Outlet /></main>
      </div>
    </div>
  );
};
export default SidebarLayout;
